import React from "react";
import "./preloader.css";

function PreLoader({ text, classText, opacity, isLoading }) {
  return (
    <>
      {isLoading && (
        <div className="fixed flex justify-center items-center h-full inset-0 z-50">
          <div
            className={
              "fixed flex justify-center items-center bg-black h-full inset-0 " +
              (opacity ? `opacity-${opacity}` : "")
            }
          ></div>
          <div className="circle"></div>
          <div className="circle-small"></div>
          <div className="circle-big"></div>
          <div className="circle-inner-inner"></div>
          <div className="circle-inner"></div>
          <span className={"text-preloader " + (classText ?? "")}>{text}</span>
        </div>
      )}
    </>
  );
}

export default PreLoader;
